/**
 * 区分 contractStatus（contracts.contract_status）
 * 出典：要件書 5.2。274（10/13 判断）で旧PCRM の 4 値（契約前・稼働中・終了・中断）に戻した。
 * 並びは旧の契約登録の選択肢の順。active・ended は値を変えていない（表示名だけ 有効→稼働中）。
 * 新規の既定は preContract（契約前）。月次チェックリストの生成・満了アラートは active（稼働中）だけを対象にする。
 */
export const CONTRACT_STATUS_VALUES = ['preContract', 'active', 'ended', 'suspended'] as const;

export type ContractStatus = (typeof CONTRACT_STATUS_VALUES)[number];

export const CONTRACT_STATUS_LABELS: Readonly<Record<ContractStatus, string>> = {
  preContract: '契約前',
  active: '稼働中',
  ended: '終了',
  suspended: '中断',
};

/** 契約を新しく作るときの既定のステータス（旧と同じ「契約前」：274 J-4） */
export const DEFAULT_CONTRACT_STATUS: ContractStatus = 'preContract';
